var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container" }, [
    _c("div", { staticClass: "page-header" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center w-100" },
        [
          _c(
            "b-button",
            {
              staticClass: "mr-3",
              attrs: { variant: "link" },
              on: {
                click: function($event) {
                  return _vm.onBack()
                }
              }
            },
            [
              _c("v-icon", {
                attrs: { name: "buttons/chevrons_left", size: 13 }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("h4", [_vm._v("Штатный персонал")]),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "custom-btn-primary ml-auto",
              attrs: { disabled: _vm.loading },
              on: {
                click: function($event) {
                  return _vm.handleSubmit()
                }
              }
            },
            [
              _vm.loading
                ? _c("b-spinner", { attrs: { small: "" } })
                : _vm._e(),
              _vm._v(" "),
              _c("v-icon", { attrs: { name: "buttons/check", size: 13 } }),
              _vm._v("\n        Сохранить\n      ")
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-body", staticStyle: { "overflow-y": "auto" } },
      [
        _c("b-skeleton-wrapper", {
          attrs: { loading: _vm.isBusy },
          scopedSlots: _vm._u([
            {
              key: "loading",
              fn: function() {
                return [
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-tabs",
                        { attrs: { card: "" } },
                        [
                          _c("b-tab", {
                            attrs: {
                              title: "Персональные данные",
                              disabled: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("b-tab", {
                            attrs: { title: "Паспортные данные", disabled: "" }
                          }),
                          _vm._v(" "),
                          _c("b-tab", {
                            attrs: { title: "Договор", disabled: "" }
                          }),
                          _vm._v(" "),
                          _c("b-tab", {
                            attrs: { title: "Рабочее место", disabled: "" }
                          }),
                          _vm._v(" "),
                          _c("b-tab", {
                            attrs: { title: "Миграционная карта", disabled: "" }
                          }),
                          _vm._v(" "),
                          _c("b-tab", {
                            attrs: { title: "Регистрация", disabled: "" }
                          }),
                          _vm._v(" "),
                          _c("b-tab", {
                            attrs: { title: "Патент", disabled: "" }
                          }),
                          _vm._v(" "),
                          _c("b-tab", {
                            attrs: { title: "Связи", disabled: "" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        { attrs: { "border-variant": "white" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { lg: "6" } },
                                [
                                  _c(
                                    "b-card",
                                    { attrs: { "bg-variant": "light" } },
                                    [
                                      _c(
                                        "b-row",
                                        { staticClass: "mt-2 mb-2" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  width: "13%",
                                                  height: "25%"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "100%",
                                                  height: "43%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mb-2" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  width: "6%",
                                                  height: "25%"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "100%",
                                                  height: "43%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mb-2" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  width: "14%",
                                                  height: "25%"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "100%",
                                                  height: "43%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mb-3" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  width: "19%",
                                                  height: "25%"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "100%",
                                                  height: "43%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mb-2" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  width: "7%",
                                                  height: "25%"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "100%",
                                                  height: "43%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mb-2" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  width: "11%",
                                                  height: "25%"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "100%",
                                                  height: "43%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mb-2" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  width: "9%",
                                                  height: "25%"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "100%",
                                                  height: "43%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mb-2" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  width: "27%",
                                                  height: "25%"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "100%",
                                                  height: "43%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mb-4" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  width: "19%",
                                                  height: "25%"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "100%",
                                                  height: "70%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "28%",
                                                  height: "50%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            },
            {
              key: "default",
              fn: function() {
                return [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.handleSubmit.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c(
                        "b-tabs",
                        { staticClass: "custom-tabs", attrs: { card: "" } },
                        [
                          _c(
                            "b-tab",
                            {
                              attrs: { active: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("v-icon", {
                                        staticClass: "mr-2",
                                        attrs: { name: "navbar/user", size: 13 }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Персональные данные")
                                      ])
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "6" } },
                                    [
                                      _c(
                                        "b-card",
                                        { staticClass: "custom-card" },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-surname",
                                                label: "Фамилия"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  state: _vm.getFieldState(
                                                    "surname"
                                                  ),
                                                  trim: ""
                                                },
                                                model: {
                                                  value: _vm.newItem.surname,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "surname",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.surname"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-name",
                                                label: "Имя"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "input-name",
                                                  type: "text",
                                                  size: "sm",
                                                  state: _vm.getFieldState(
                                                    "name"
                                                  ),
                                                  trim: ""
                                                },
                                                model: {
                                                  value: _vm.newItem.name,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "name",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.name"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-patronymic",
                                                label: "Отчество"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  trim: ""
                                                },
                                                model: {
                                                  value: _vm.newItem.patronymic,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "patronymic",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.patronymic"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-citizenship",
                                                label: "Гражданство"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  trim: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.citizenship,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "citizenship",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.citizenship"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-inn",
                                                label: "ИНН"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  trim: ""
                                                },
                                                model: {
                                                  value: _vm.newItem.inn,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "inn",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.inn"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-snils",
                                                label: "СНИЛС"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  trim: ""
                                                },
                                                model: {
                                                  value: _vm.newItem.snils,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "snils",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.snils"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-status",
                                                label: "Статус"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  trim: ""
                                                },
                                                model: {
                                                  value: _vm.newItem.status,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.status"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group_location_work_name",
                                                label: "Название объекта"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  trim: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .location_work_name,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "location_work_name",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.location_work_name"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-note",
                                                label: "Примечание"
                                              }
                                            },
                                            [
                                              _c("b-form-textarea", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  trim: ""
                                                },
                                                model: {
                                                  value: _vm.newItem.note,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "note",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.note"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              attrs: { size: "md" },
                                              model: {
                                                value: _vm.newItem.active,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newItem,
                                                    "active",
                                                    $$v
                                                  )
                                                },
                                                expression: "newItem.active"
                                              }
                                            },
                                            [_vm._v("Активен / не активен")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("v-icon", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          name: "buttons/passport",
                                          size: 13
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Паспортные данные")])
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "6" } },
                                    [
                                      _c(
                                        "b-card",
                                        { staticClass: "custom-card" },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport-series",
                                                label: "Серия"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: "Введите серию"
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.passport_series,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "passport_series",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport_series"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport-number",
                                                label: "Номер"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: "Введите номер"
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.passport_number,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "passport_number",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport_number"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport-birthdate",
                                                label: "Дата рождения"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .passport_birth_date,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "passport_birth_date",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport_birth_date"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport-birthplace",
                                                label: "Место рождения"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder:
                                                    "Введите место рождения"
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .passport_birth_place,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "passport_birth_place",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport_birth_place"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport-issued-by",
                                                label: "Кем выдан"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder:
                                                    "Введите Кем выдан"
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .passport_issued_by,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "passport_issued_by",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport_issued_by"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-passport-issue-date",
                                                label: "Дата выдачи"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .passport_issue_date,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "passport_issue_date",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport_issue_date"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id:
                                                  "group-passport-department-code",
                                                label: "Код подразделения"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder:
                                                    "Введите Код подразделения"
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .passport_department_code,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "passport_department_code",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport_department_code"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id:
                                                  "group-passport-registration-address",
                                                label: "Адрес регистрации"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled,
                                                  placeholder:
                                                    "Введите Адрес регистрации"
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .passport_registration_address,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "passport_registration_address",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.passport_registration_address"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "6" } },
                                    [
                                      _c(
                                        "b-card",
                                        { staticClass: "custom-card" },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-registration-place",
                                                label: "Адрес регистрации"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .registration_place,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "registration_place",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.registration_place"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-registration-date",
                                                label: "Дата регистрации"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .registration_date,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "registration_date",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.registration_date"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id:
                                                  "group-registration-expiration",
                                                label:
                                                  "Дата окончания регистрации"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .registration_expiration,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "registration_expiration",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.registration_expiration"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("v-icon", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          name: "navbar/staff_badge",
                                          size: 13
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Рабочие данные")])
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "6" } },
                                    [
                                      _c(
                                        "b-card",
                                        { staticClass: "custom-card" },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-organization",
                                                label: "Организация"
                                              }
                                            },
                                            [
                                              _c("organization-select", {
                                                ref: "organization_select",
                                                attrs: {
                                                  "is-disabled": _vm.isDisabled,
                                                  value:
                                                    _vm.newItem.organization_id
                                                },
                                                on: {
                                                  onSelect: _vm.onSelectOrg
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-job-title-select",
                                                label: "Должность"
                                              }
                                            },
                                            [
                                              _c("job-title-select", {
                                                attrs: {
                                                  "is-disabled": _vm.isDisabled,
                                                  value:
                                                    _vm.newItem.job_title_id
                                                },
                                                on: {
                                                  onSelect: _vm.onSelectJobTitle
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-department-select",
                                                label: "Подразделение"
                                              }
                                            },
                                            [
                                              _c("department-select", {
                                                attrs: {
                                                  "is-disabled": _vm.isDisabled,
                                                  value:
                                                    _vm.newItem.department_id
                                                },
                                                on: {
                                                  onSelect:
                                                    _vm.onSelectDepartment
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-okz",
                                                label: "ОКЗ",
                                                description:
                                                  "Общероссийский классификатор занятий"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  trim: ""
                                                },
                                                model: {
                                                  value: _vm.newItem.okz,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "okz",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.okz"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-work-place",
                                                label: "Место работы"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  trim: ""
                                                },
                                                model: {
                                                  value: _vm.newItem.work_place,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "work_place",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.work_place"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-work-nature",
                                                label: "Характер работы"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  trim: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.work_nature,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "work_nature",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.work_nature"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-salary",
                                                label: "Оклад"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "number",
                                                  size: "sm",
                                                  trim: ""
                                                },
                                                model: {
                                                  value: _vm.newItem.salary,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "salary",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression: "newItem.salary"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-salary-rate",
                                                label: "Ставка"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "number",
                                                  size: "sm",
                                                  trim: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.salary_rate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "salary_rate",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.salary_rate"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-contract-salary",
                                                label: "Зарплата по договору"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "number",
                                                  size: "sm",
                                                  trim: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.contract_salary,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "contract_salary",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.contract_salary"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "6" } },
                                    [
                                      _c(
                                        "b-card",
                                        { staticClass: "custom-card" },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-contract-number",
                                                label: "Номер договора"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "number",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.contract_number,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "contract_number",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.contract_number"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-contract-add-date",
                                                label: "Дата приёма"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .contract_add_date,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "contract_add_date",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.contract_add_date"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-contract-expiration",
                                                label: "Дата окончания договора"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .contract_expiration,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "contract_expiration",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.contract_expiration"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-contract-signed",
                                                label: "Договор подписан"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-form-checkbox",
                                                {
                                                  attrs: {
                                                    size: "md",
                                                    disabled: _vm.isDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem
                                                        .contract_signed,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "contract_signed",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.contract_signed"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.newItem
                                                        .contract_signed
                                                        ? "Да"
                                                        : "Нет"
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-contract-received",
                                                label: "Договор получен"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-form-checkbox",
                                                {
                                                  attrs: {
                                                    size: "md",
                                                    disabled: _vm.isDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem
                                                        .contract_received,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "contract_received",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.contract_received"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.newItem
                                                          .contract_received
                                                          ? "Да"
                                                          : "Нет"
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("hr"),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id:
                                                  "group-contract-dismiss-date",
                                                label: "Дата увольнения"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .contract_dismiss_date,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "contract_dismiss_date",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.contract_dismiss_date"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id:
                                                  "group-contract-dismiss-reason",
                                                label: "Причина увольнения"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .contract_dismiss_reason,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "contract_dismiss_reason",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.contract_dismiss_reason"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("hr"),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id:
                                                  "group-contract-add-notification",
                                                label:
                                                  "Дата отправки уведомления о заключении договора (УВЗ)"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .contract_add_notification,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "contract_add_notification",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.contract_add_notification"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id:
                                                  "group-contract-dismiss-notification",
                                                label:
                                                  "Дата отправки уведомления о расторжении договора"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .contract_dismiss_notification,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "contract_dismiss_notification",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.contract_dismiss_notification"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("v-icon", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          name: "navbar/stamp",
                                          size: 13
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Разрешительные документы")
                                      ])
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "6" } },
                                    [
                                      _c(
                                        "b-card",
                                        { staticClass: "custom-card" },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id:
                                                  "group-migration-card-number",
                                                label: "Миграционная карта"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .migration_card_number,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "migration_card_number",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.migration_card_number"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id:
                                                  "group-migration-entry-date",
                                                label: "Дата въезда"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .migration_entry_date,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "migration_entry_date",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.migration_entry_date"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "6" } },
                                    [
                                      _c(
                                        "b-card",
                                        { staticClass: "custom-card" },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-patent-number",
                                                label: "Патент / ВНЖ"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "text",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.patent_number,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "patent_number",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.patent_number"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-patent-issue-date",
                                                label: "Дата выдачи патента"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .patent_issue_date,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "patent_issue_date",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.patent_issue_date"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-patent-expiration",
                                                label: "Дата окончания патента"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  type: "date",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .patent_expiration,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "patent_expiration",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.patent_expiration"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("v-icon", {
                                        staticClass: "mr-2",
                                        attrs: { name: "navbar/link", size: 13 }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Связи")])
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "6", md: "12" } },
                                    [
                                      _c(
                                        "b-list-group",
                                        { attrs: { size: "sm" } },
                                        [
                                          _c(
                                            "b-list-group-item",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between align-items-center",
                                              attrs: {
                                                variant: _vm.getWorkerVariant()
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Исполнитель\n                      "
                                              ),
                                              _c("div", [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.newItem.worker_id !=
                                                        null
                                                        ? "id: " +
                                                            _vm.newItem
                                                              .worker_id
                                                        : ""
                                                    ) +
                                                    "\n                      "
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-list-group-item",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between align-items-center",
                                              attrs: {
                                                variant: _vm.getUserVariant()
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Пользователь\n                      "
                                              ),
                                              _c("div", [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.newItem.user_id !=
                                                        null
                                                        ? "id: " +
                                                            _vm.newItem.user_id
                                                        : ""
                                                    ) +
                                                    "\n                      "
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28a02051", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28a02051","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Staff/Staff.vue
// module id = null
// module chunks = 